import { Component } from '@theme/component';

/**
 * @typedef {{timer: HTMLTimeElement, days: HTMLElement, hours: HTMLElement, minutes: HTMLElement, seconds: HTMLElement, status: HTMLElement}} AnnouncementCountdownRefs
 */

/** @extends {Component<AnnouncementCountdownRefs>} */
class AnnouncementCountdown extends Component {
  requiredRefs = ['timer', 'days', 'hours', 'minutes', 'seconds', 'status'];

  /** @type {number | undefined} */
  #timeout;

  connectedCallback() {
    super.connectedCallback();
    this.#start();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#start();
  }

  disconnectedCallback() {
    this.#stop();
    super.disconnectedCallback();
  }

  #start() {
    this.#stop();
    const deadline = Date.parse(this.dataset.deadline ?? '');

    if (Number.isNaN(deadline)) {
      this.refs.timer.hidden = true;
      return;
    }

    this.refs.timer.dateTime = new Date(deadline).toISOString();
    this.#update(deadline);
  }

  /** @param {number} deadline */
  #update(deadline) {
    const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));

    if (remaining === 0) {
      this.refs.timer.hidden = true;
      this.refs.status.textContent = this.refs.status.dataset.expiredText ?? '';
      return;
    }

    this.refs.timer.hidden = false;
    this.refs.days.textContent = String(Math.floor(remaining / 86400)).padStart(2, '0');
    this.refs.hours.textContent = String(Math.floor((remaining % 86400) / 3600)).padStart(2, '0');
    this.refs.minutes.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    this.refs.seconds.textContent = String(remaining % 60).padStart(2, '0');
    this.#timeout = window.setTimeout(() => this.#update(deadline), 1020 - (Date.now() % 1000));
  }

  #stop() {
    if (this.#timeout !== undefined) {
      window.clearTimeout(this.#timeout);
      this.#timeout = undefined;
    }
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
